/*eslint-disable no-undef*/
require('expose-loader?exposes=Components!./components');
/*eslint-enable no-undef*/
